import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

/**
 * Guard to check if the current user has one of the allowed roles before activating a route.
 *
 * @param {*} route
 * @param {*} state
 * @returns {*}
 */
export const userRoleGuard: CanActivateFn = ( route, state ) => {
    const auth = inject( AuthService );
    const router = inject( Router );

    const allowedRoles = route.data?.[ 'allowedRoles' ] as string[] | undefined;
    const role = auth.currentUser()?.role;

    if ( allowedRoles?.includes( role ) ) {
        return true;
    }
    return router.createUrlTree( [ '/403' ] );
};
